var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Header"),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "main" } },
        [
          _c("div", { attrs: { id: "menustores" } }),
          _vm._v(" "),
          _c("div", { attrs: { id: "vitrine" } }, [
            _vm.project && _vm.project.ProjectStore
              ? _c("div", { attrs: { id: "vitrineImage" } }, [
                  _c("img", { attrs: { src: _vm.project.ProjectStore.image } })
                ])
              : _c("div", { attrs: { id: "vitrineImage" } }, [
                  _c("img", { attrs: { src: _vm.vitrine } })
                ]),
            _vm._v(" "),
            _c("div", { staticClass: "container-fluid" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-12" }, [
                      _vm.project
                        ? _c("div", [
                            _c("h3", [
                              _vm._v(
                                "Essa é a loja de descontos do bem exclusiva do projeto"
                              )
                            ]),
                            _vm._v(" "),
                            _c("h1", [_vm._v(_vm._s(_vm.project.Info.title))]),
                            _vm._v(" "),
                            _c("h4", [
                              _vm._v(
                                "Ao comprar qualquer produto em uma das lojas conveniadas, você estará automaticamente ajudando este projeto social."
                              )
                            ]),
                            _vm._v(" "),
                            _c("h4", [
                              _vm._v(
                                "Compartilhe com seus amigos e ajude a transformar vidas!"
                              )
                            ])
                          ])
                        : _c("div", [
                            _c(
                              "h3",
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "fa-spin",
                                  attrs: { icon: ["fas", "spinner"] }
                                })
                              ],
                              1
                            )
                          ]),
                      _vm._v(" "),
                      !_vm.project && !this.$route.params.slug
                        ? _c("div", [
                            _c("h1", [
                              _vm._v(
                                "Ajude nossos projetos com os Descontos do Bem!"
                              )
                            ]),
                            _vm._v(" "),
                            _c("h4", [
                              _vm._v("Com as nossas ofertas imperdíveis!")
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.couponsVitrine && _vm.couponsVitrine.length == 0
                        ? _c("div", { staticClass: "categories-list" }, [
                            _c("h5", [_vm._v("Aguarde, carregando...")])
                          ])
                        : _c(
                            "div",
                            { staticClass: "categories-list" },
                            [
                              _c(
                                "carousel",
                                {
                                  attrs: {
                                    "per-page": _vm.perPage,
                                    "mouse-drag": false,
                                    "pagination-enabled": false,
                                    "navigation-enabled": true
                                  }
                                },
                                _vm._l(_vm.couponsVitrine, function(coupon, s) {
                                  return _c("slide", { key: s }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "category",
                                        on: {
                                          click: function($event) {
                                            return _vm.openCouponModal(coupon)
                                          }
                                        }
                                      },
                                      [
                                        coupon.value > 100
                                          ? _c("span", [
                                              _vm._v(
                                                "R$" + _vm._s(coupon.value)
                                              )
                                            ])
                                          : _c("span", [
                                              _vm._v(_vm._s(coupon.value) + "%")
                                            ]),
                                        _vm._v(" "),
                                        _c("img", {
                                          attrs: { src: coupon.image }
                                        })
                                      ]
                                    )
                                  ])
                                }),
                                1
                              )
                            ],
                            1
                          )
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { attrs: { id: "products" } }, [
            _c("div", { staticClass: "container" }, [
              _vm.project && _vm.campaigns && _vm.campaigns.length > 0
                ? _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-12" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row" },
                        _vm._l(_vm.campaigns, function(c) {
                          return _c(
                            "div",
                            {
                              key: c.CouponId,
                              staticClass: "col-md-3 product"
                            },
                            [
                              _c(
                                "a",
                                { attrs: { target: "_blank", href: c.url } },
                                [
                                  _c("div", { staticClass: "image" }, [
                                    _c("img", {
                                      attrs: {
                                        src:
                                          "https://via.placeholder.com/500x500?text=Campanha"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "price" }, [
                                      _c("b", [
                                        _vm._v(
                                          "Por " +
                                            _vm._s(_vm.formatCurrency(c.price))
                                        )
                                      ])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "info" }, [
                                    _c("h4", [_vm._v(_vm._s(c.name))])
                                  ])
                                ]
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.favoriteStores.length > 0
                ? _c("div", { staticClass: "row mb-4" }, [
                    _c("div", { staticClass: "col-md-12" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _vm.stores.length == 0
                            ? _c(
                                "div",
                                { staticClass: "col-md-12 loading-coupons" },
                                [_c("h5", [_vm._v("Aguarde, carregando...")])]
                              )
                            : _vm._l(_vm.favoriteStores, function(store, c) {
                                return _c(
                                  "div",
                                  { key: c, staticClass: "col-md-2 store" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "image" },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: _vm.getStoreUrl(store)
                                            }
                                          },
                                          [
                                            _c("img", {
                                              attrs: { src: store.logo }
                                            })
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              })
                        ],
                        2
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.products
                ? _c("div", { staticClass: "row mt-4" }, [
                    _c("div", { staticClass: "col-md-12" }, [
                      _vm._m(2),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _vm.products.length == 0
                            ? _c(
                                "div",
                                { staticClass: "col-md-12 loading-coupons" },
                                [_c("h5", [_vm._v("Aguarde, carregando...")])]
                              )
                            : _vm._l(_vm.products, function(product, c) {
                                return _c(
                                  "div",
                                  { key: c, staticClass: "col-md-3 product" },
                                  [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          target: "_blank",
                                          href: product.link
                                        }
                                      },
                                      [
                                        _c("div", { staticClass: "image" }, [
                                          _c("img", {
                                            attrs: { src: product.thumbnail }
                                          }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "price" }, [
                                            _c("b", [
                                              _vm._v(
                                                "Por " +
                                                  _vm._s(
                                                    _vm.formatCurrency(
                                                      product.price
                                                    )
                                                  )
                                              )
                                            ])
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "info" }, [
                                          _c("h4", [
                                            _vm._v(_vm._s(product.name))
                                          ])
                                        ])
                                      ]
                                    )
                                  ]
                                )
                              })
                        ],
                        2
                      )
                    ])
                  ])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("div", { attrs: { id: "latest" } }, [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "latest-coupons" },
                    [
                      _vm.couponsFeatured.length == 0
                        ? _c(
                            "div",
                            { staticClass: "col-md-12 loading-coupons" },
                            [_c("h5", [_vm._v("Aguarde, carregando...")])]
                          )
                        : _vm._l(_vm.couponsFeatured, function(coupon, c) {
                            return _c(
                              "div",
                              { key: c, staticClass: "col-md-6" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "row coupon",
                                    on: {
                                      click: function($event) {
                                        return _vm.openCouponModal(coupon)
                                      }
                                    }
                                  },
                                  [
                                    _c("div", { staticClass: "col-md-5" }, [
                                      _c("div", { staticClass: "image" }, [
                                        _c("img", {
                                          attrs: { src: coupon.image }
                                        })
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-md-7" }, [
                                      coupon.category
                                        ? _c(
                                            "div",
                                            { staticClass: "categorie" },
                                            [
                                              _c("span", [
                                                _vm._v(_vm._s(coupon.category))
                                              ])
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "coupon-info" },
                                        [
                                          _c("div", { staticClass: "info" }, [
                                            _c("h4", [
                                              _vm._v(_vm._s(coupon.store))
                                            ]),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(_vm._s(coupon.description))
                                            ]),
                                            _vm._v(" "),
                                            coupon.value >= 100
                                              ? _c(
                                                  "span",
                                                  { staticClass: "value" },
                                                  [
                                                    _vm._v(
                                                      "R$ " +
                                                        _vm._s(coupon.value)
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            coupon.value < 100 &&
                                            coupon.value > 0
                                              ? _c(
                                                  "span",
                                                  { staticClass: "value" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(coupon.value) + "%"
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !coupon.value ||
                                            coupon.value == 0 ||
                                            coupon.value == ""
                                              ? _c(
                                                  "span",
                                                  { staticClass: "value" },
                                                  [_vm._v(" ")]
                                                )
                                              : _vm._e()
                                          ]),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "action" }, [
                                            _c(
                                              "button",
                                              {
                                                staticClass: "btn",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.openCouponModal(
                                                      coupon
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("Ver Desconto")]
                                            )
                                          ])
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              ]
                            )
                          })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.couponsFeatured.length !== 0 &&
                  _vm.couponsFeatured.length !== _vm.coupons.length
                    ? _c("div", { staticClass: "view-all" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn",
                            on: {
                              click: function($event) {
                                return _vm.showMore()
                              }
                            }
                          },
                          [_vm._v("Ver Mais")]
                        )
                      ])
                    : _vm._e()
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { attrs: { id: "stores" } }, [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _vm._m(4),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _vm.stores.length == 0
                        ? _c(
                            "div",
                            { staticClass: "col-md-12 loading-coupons" },
                            [_c("h5", [_vm._v("Aguarde, carregando...")])]
                          )
                        : _vm._l(_vm.stores, function(store, c) {
                            return _c(
                              "div",
                              { key: c, staticClass: "col-md-2 store" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "image" },
                                  [
                                    _c(
                                      "router-link",
                                      { attrs: { to: _vm.getStoreUrl(store) } },
                                      [
                                        _c("img", {
                                          attrs: { src: store.logo }
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          })
                    ],
                    2
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade" } }, [
            _vm.showScrollButton
              ? _c("div", { attrs: { id: "scrollToTop" } }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.scrollToTop()
                        }
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: {
                          icon: ["fas", "chevron-circle-up"],
                          size: "lg"
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("CouponModal", {
        ref: "couponModal",
        attrs: { coupon: _vm.selectedCoupon }
      }),
      _vm._v(" "),
      _c("Footer"),
      _vm._v(" "),
      _vm.loading ? _c("Loading") : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "mustLogin",
          attrs: { "hide-footer": "", title: "Você não está logado" }
        },
        [
          _c("div", { staticClass: "d-block text-center" }, [
            _c("h3", [
              _vm._v("Olá! Você precisa estar logado para visualizar o cupom.")
            ])
          ]),
          _vm._v(" "),
          _c(
            "b-btn",
            {
              staticClass: "mt-3",
              attrs: { variant: "outline-success", block: "" },
              on: { click: _vm.goToLogin }
            },
            [_vm._v("Entrar")]
          ),
          _vm._v(" "),
          _c(
            "b-btn",
            {
              staticClass: "mt-3",
              attrs: { variant: "outline-danger", block: "" },
              on: { click: _vm.hideModal }
            },
            [_vm._v("Fechar")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "searchModal",
          attrs: {
            id: "searchModal",
            "hide-footer": "",
            title: "Selecione um resultado"
          }
        },
        [
          _vm._l(_vm.resultStores, function(store, s) {
            return _c("div", { key: s }, [
              _vm.resultStores && _vm.resultStores.length > 0
                ? _c("div", { staticClass: "d-block text-center store" }, [
                    _c(
                      "a",
                      {
                        attrs: { href: "/descontosdobem/store/" + store.slug }
                      },
                      [_vm._v(_vm._s(store.Info.name))]
                    )
                  ])
                : _vm._e()
            ])
          }),
          _vm._v(" "),
          !_vm.resultStores || _vm.resultStores.length == 0
            ? _c("div", { staticClass: "d-block text-center" }, [
                _c("h5", [_vm._v("Nenhuma loja encontrada.")])
              ])
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-section" }, [
      _c("h3", [_vm._v("Ofertas da Click2Giv")]),
      _vm._v(" "),
      _c("span", [_vm._v("Ajude o projeto com essas ofertas espetaculares!")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-section" }, [
      _c("h3", [_vm._v("Lojas para Você")]),
      _vm._v(" "),
      _c("span", [
        _vm._v("Selecionamos algumas lojas com base nas suas preferências!")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-section" }, [
      _c("h3", [_vm._v("Produtos em Destaque")]),
      _vm._v(" "),
      _c("span", [_vm._v("Confira aqui as melhores ofertas da semana!")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-section" }, [
      _c("h3", [_vm._v("Descontos Imperdíveis")]),
      _vm._v(" "),
      _c("span", [_vm._v("Os melhores descontos da semana!")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-section" }, [
      _c("h3", [_vm._v("Todas as Lojas")]),
      _vm._v(" "),
      _c("span", [
        _vm._v("Acesse as melhores lojas e aproveite nossos descontos!")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68dab7c7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68dab7c7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/descontosdobem/MainDescontos.vue
// module id = null
// module chunks = 